import { Button, Typography, message } from 'antd';

import { css } from '@emotion/react';

import BaseCard from '@/components/shared/BaseCard';
import Shelf from '@/components/shared/Shelf';
import { getCdnUrl } from '@/helpers';
import { useAcceptInviteMutation, useFetchAllInvitesDataQuery, useRefuseInviteMutation } from '@/services/invites';
import styled, { StyledProp } from '@/styled';

const InvitesShelf = ({ ...rest }: StyledProp) => {
  const { data, isFetching } = useFetchAllInvitesDataQuery({ page: 1 });
  const [acceptInvite, { isLoading: acceptingInvite }] = useAcceptInviteMutation();
  const [refuseInvite, { isLoading: refusingInvite }] = useRefuseInviteMutation();

  if (!data?.data.length && !isFetching) {
    return null;
  }

  const handleAcceptInvite = (hash: string) => () => {
    acceptInvite(hash)
      .then(() => {
        message.success('Convite aceito com sucesso!');
      })
      .catch(() => {
        message.error('Erro ao aceitar convite');
      });
  };

  const handleRefuseInvite = (hash: string) => () => {
    refuseInvite(hash)
      .then(() => {
        message.success('Convite recusado com sucesso!');
      })
      .catch(() => {
        message.error('Erro ao recusar o convite');
      });
  };

  return (
    <Shelf
      title={
        <Typography.Title level={4} ellipsis>
          Convites
        </Typography.Title>
      }
      shelfProps={{
        isFetching
      }}
      carouselProps={{ slidesToShow: 4 }}
      {...rest}
    >
      <>
        {data?.data.map(invite => (
          <swiper-slide key={invite.id}>
            <div className='buttons-hover-container'>
              <div className='button-hover-container-img'>
                <div className='buttons-hover'>
                  <Button loading={acceptingInvite} onClick={handleAcceptInvite(invite.hash)}>
                    Aceitar Convite
                  </Button>
                  <Button loading={refusingInvite} onClick={handleRefuseInvite(invite.hash)}>
                    Recusar Convite
                  </Button>
                </div>
              </div>
              <BaseCard
                image={{
                  src: getCdnUrl(
                    invite.course.customization.new_card_background,
                    invite.course.customization.new_avatar,
                    invite.course.customization.avatar
                  ),
                  aspect: '16:9',
                  alt: invite.course.title
                }}
                id={`invite-card-${invite.id}`}
                internalSpace={16}
              >
                <Typography.Paragraph ellipsis>{invite.course.title}</Typography.Paragraph>
              </BaseCard>
            </div>
          </swiper-slide>
        ))}
      </>
    </Shelf>
  );
};

export default styled(InvitesShelf)(
  ({ theme }) => css`
    .base-card-data {
      .ant-typography {
        margin-bottom: 0;
        color: ${theme.colorTextSecondary};
      }
    }

    .button-hover-container-img {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      position: absolute;
      height: calc(100% - 41px);
      z-index: 5;
      width: 100%;
      opacity: 0;
      transition: ${theme.motionDurationFast};
      background: ${theme.palette.alpha('#000000', 0.8)};
      border-radius: ${theme.borderRadius}px;
    }

    .button-hover-container-img:hover {
      opacity: 1;
    }

    .buttons-hover {
      display: flex;
      width: 100%;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 0 ${theme.space.pxToRem(48)};

      button {
        width: 100%;
        padding: 7px 35px;
        height: auto;
        min-width: 120px;
      }

      button:last-of-type {
        margin-top: ${theme.space.pxToRem(24)};
      }
    }
  `
);
